import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Overview from "./pages/Overview";
import Players from "./pages/Players";
import Claims from "./pages/Claims";
import Clubs from "./pages/Clubs";
import ClubDetail from "./pages/ClubDetail";
import Tournaments from "./pages/Tournaments";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Admin data is edited constantly in this app; a stale window would
      // show an operator their own change reverting.
      staleTime: 0,
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Layout holds the admin-session guard, so every nested route is
              protected by construction rather than by remembering to wrap it. */}
          <Route element={<Layout />}>
            <Route index element={<Overview />} />
            <Route path="players" element={<Players />} />
            <Route path="claims" element={<Claims />} />
            <Route path="clubs" element={<Clubs />} />
            <Route path="clubs/:clubId" element={<ClubDetail />} />
            <Route path="tournaments" element={<Tournaments />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
